import { createSlice } from '@reduxjs/toolkit'
import DocumentsServices from '../../services/documentsServices';


const initialState = {
    docStatus: []
};

const documentStatusSlice = createSlice({
  name: 'docStatus',
  initialState,
  reducers: {
    documentStatusLoaded(state, action) {
      state.docStatus = action.payload;
    }
  },
})

export const { documentStatusLoaded } = documentStatusSlice.actions;

export default documentStatusSlice.reducer;

export const fetchDocumentStatusList = () => async (dispatch) => {

  try {
    const respData = await DocumentsServices.getDocumentStatus();
    if (respData.success) {
      const documentStatusList = respData.responseObject.value.list;    

      if(documentStatusList){
        const objectsArray = documentStatusList.map((item) => ({ value: item.id, label: item.name }));
        dispatch(documentStatusLoaded(objectsArray));
      }
    }
  } catch (error) {
    console.error('Failed to fetch:', error.message);
  }
};

